import { find } from 'lodash'

export function insertGridFilesExtraData (data) {
  const { state, gridId, cellKey } = data
  const dataGrids = state.models_dashboardModel

  for (let rowKey in dataGrids[gridId]) {
    const row = dataGrids[gridId][rowKey]

    delete row[`$${cellKey}$display`]

    if (!row[cellKey]) continue

    const files = row[cellKey].split(',')
    const $cell$display = []

    for (let id of files) {
      if (!state.files[id]) {
        console.error(`[DataGrid Parser] file not found: ${gridId}.${rowKey}.${cellKey}: ${id}`)
        continue
      }
      $cell$display.push(state.files[id])
    }

    row[`$${cellKey}$display`] = $cell$display
  }
}

export function insertCellFilesExtraData (data) {
  const { state, gridId, rowKey, cellKey } = data
  const row = state.models_dashboardModel[gridId][rowKey]

  delete row[`$${cellKey}$display`]

  if (!row[cellKey]) return

  const files = row[cellKey].split(',')
  const $cell$display = []

  for (let id of files) {
    $cell$display.push(state.files[id])
  }

  row[`$${cellKey}$display`] = $cell$display
}
